export default __webpack_public_path__ + "static/media/webTabletScreen.1eca546f.png";